import React, { Component } from 'react'
import './camera-add.less';
import { globalCamera } from '@/interface/camera';
import { Form, Input, Select, Row, Col, Space, Button, InputNumber, message } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { createCamera } from '@/config/api/camera';
import { ProjectContext } from '@/config/context';
import { globalInstall } from '@/interface/install';
import { inject, observer } from 'mobx-react';
import UserStore from '@/store/user-store';
import axios from '@/config/axios';
import { queryEnterprisesInstallations } from '@/config/api/global-install';

const { Option } = Select;
interface IProps {
    onCancel?: () => void
    onSave?: () => void
    gCameras: globalCamera[]
    userStore?: UserStore
}

interface IState {
    gCameraManufacturer: any[]
    gCameraMarking: string[]
    cameraType: number
    gInstalls: globalInstall[]
    loading: boolean
}
@inject('userStore')
@observer
export default class CameraAddPanel extends Component<IProps, IState> {
    static contextType = ProjectContext;
    formRef = React.createRef<FormInstance>();
    state = {
        gCameraManufacturer: [],
        gCameraMarking: [],
        cameraType: 1,
        gInstalls: [],
        loading: false,
    }
    componentDidMount() {
        let gCameras = this.props.gCameras;
        let gCameraManufacturer = Array.from(new Set(
            gCameras.map(item => item.manufacturer)
        ))
        this.setState({
            gCameraManufacturer: gCameraManufacturer,
        })
    }

    onManufacturerChange = (value) => {
        let gCameras = this.props.gCameras;
        let gCameraMarking = gCameras.filter(item => item.manufacturer === value).map(item => {return `${item.name}__${item.marking}`});
        this.setState({
            gCameraMarking: gCameraMarking,
            cameraType: value,
        })
        this.formRef.current?.setFieldsValue({
            // manufacturer: null,
            channel_count: null,
            wireless_type: null,
        })
        queryEnterprisesInstallations(this.props.userStore._enterpriseId)
        .then(res => {
            this.setState({
                gInstalls: res.data || []
            })
        })
    }

    onMarkingChange = (value) => {
        let marking = value.split("__")[1]
        let gCamera = this.props.gCameras.find(item => item.marking === marking);
        this.formRef.current?.setFieldsValue({
            protocol: gCamera.protocol
        })
    }

    onSave = (values) => {
        this.setState({
            loading: true,
        })
        let { copy, marking, ...data } = values;
        let name = marking.split("__")[0]
        marking = marking.split("__")[1]
        
        data = {
            ...data,
            name: name,
            marking: marking,
            project_id: this.context,
        }
        let promiseList = [];
        for (let idx = 0; idx < copy + 1; idx++) {
            if (idx >= 1) {
                promiseList.push(createCamera({...data, name: `${data.name}-${idx}`}));
            } else {
                promiseList.push(createCamera(data));
            }
            
        }
        axios.all([...promiseList])
        .then(res => {
            this.setState({
                loading: false,
            })
            this.props.onSave();
        }).catch(err => {
            message.error('创建失败');
            console.log(err);
            this.setState({
                loading: false,
            })
        })
    }

    render() {
        return (
            <div className="camera-add-container">
                <Form
                    ref={this.formRef}
                    labelCol={{ span: 5 }}
                    autoComplete="off"
                    onFinish={this.onSave}>
                    <Row gutter={10}>
                        <Col xs={24} xl={12}>
                            <Form.Item label="编号" name="camera_id" rules={[{ required: true }]}>
                                <Input placeholder="请输入摄像头在项目中的编号" />
                            </Form.Item>
                            <Form.Item label="厂家" name="manufacturer" rules={[{ required: true }]}>
                                <Select onChange={this.onManufacturerChange}>
                                    {this.state.gCameraManufacturer.map(item => (
                                        <Option key={item} value={item}>{item}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item label="型号" name="marking" rules={[{ required: true }]}>
                                <Select onChange={this.onMarkingChange}>
                                    {this.state.gCameraMarking.map(item => (
                                        <Option key={item} value={item}>{item}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item label="复制个数" name="copy" initialValue={0}>
                                <InputNumber min={0} step={1} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} xl={12}>

                            <Form.Item label="设备号" name="device_id" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="通道号" name="channel_id" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                <div style={{ textAlign: 'right' }}>
                    <Space size="large">
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>保存</Button>
                        <Button onClick={this.props.onCancel} >取消</Button>
                    </Space>
                </div>
                </Form>
            </div >
        )
    }
}
